module.exports = __webpack_public_path__ + "img/accessory_shirt_01.0f3de217.svg";